import React from "react";
import { createRoot } from "react-dom/client";
import SearchPage from "../javascript/search/SearchPage";
import NewSearchPage from "../javascript/search/components/SearchPageV2";

const waitForContainer = () => {
  return new Promise((resolve) => {
    const checkContainer = () => {
      const container = document.getElementById("search-main-container");
      if (container) {
        resolve(container);
      } else {
        setTimeout(checkContainer, 10);
      }
    };
    checkContainer();
  });
};

const initializeApp = async () => {
  try {
    const container = await waitForContainer();
    
    if (container._reactRoot) {
      return;
    }
    
    const root = createRoot(container);
    container._reactRoot = root;
    
    root.render(
      window.featureFlags?.newHomeSearchDesign ? <NewSearchPage /> : <SearchPage />
    );
  } catch (error) {
    console.error("Error initializing search app:", error);
  }
};

document.addEventListener('DOMContentLoaded', initializeApp);
document.addEventListener('turbo:load', initializeApp);
document.addEventListener('turbo:render', initializeApp);

if (document.readyState !== 'loading') {
  initializeApp();
}